var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLbc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_722_32983)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9 18C13.9706 18 18 13.9706 18 9C18 4.02944 13.9706 0 9 0C4.02944 0 0 4.02944 0 9C0 13.9706 4.02944 18 9 18Z",
    fill: "#006149"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.599 9.66595L13.1507 9.55402L13.2868 9.00839L14.6846 9.3577L14.3359 10.7555L13.7897 10.6194L13.9106 10.1345L8.92012 13.2243L3.38568 10.4591V8.34858L9.13668 4.75195L14.4101 7.32427V8.19277L8.92068 11.6032L4.84424 9.58214L5.09399 9.07814L8.89031 10.9603L13.8476 7.88002V7.67583L9.17043 5.39433L3.94874 8.6602V10.1115L8.89143 12.5808L13.599 9.66595Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_722_32983"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLbc);
export default __webpack_public_path__ + "static/media/lbc.35c77ca3fd972aa6c827a2bc5617728a.svg";
export { ForwardRef as ReactComponent };